import styled from 'styled-components';

export const Label = styled.div.attrs({ className: 'dsc-fieldLabel' })`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  color: var(--field-label-color, var(--zeroGrey));
  opacity: ${({ disabled }) => disabled && '0.6'};
  ${({ $justifyContent }) => $justifyContent && `justify-content: ${$justifyContent};`}
  ${({ $isUpperCase }) => $isUpperCase && 'text-transform: uppercase;'}
`;
export const Required = styled.div`
  color: var(--error);
  font-size: 20px;
  font-weight: 400;
  line-height: 14px;
  margin: 2px 0 0 -5px;
`;
